import Vue from "vue";
import axios from "axios";
import configuration from "@/utils/configuration";
import { handleError } from "@/utils/errorHandler";


  const getDefaultState = () => {
    return {
    coachCourse: [],
    courseStudent: [],
    checkinTime: null,  
    classCheckIn: null,  
    classSummary:[],  
    loading: {},
    error: null,
    falseMessage:{}
  };
};
const state = getDefaultState();

export default {
  namespaced: true,
  state,
  mutations: {
    RESET_CLASS(state) {
      Object.assign(state, getDefaultState());
    },
    SET_COURSECOACH(state, coachCourse) {
      state.coachCourse = coachCourse;
    },
    SET_COURSESTUDENT(state, courseStudent) {
      state.courseStudent = courseStudent;
    },
    SET_CHECKIN_TIME(state, checkinTime) {
      state.checkinTime = checkinTime;  
    },
    SET_LOADING(state, { action, status }) {
      Vue.set(state.loading, action, status);
    },
    SET_ERROR(state, { action, message }) {
      Vue.set(state.falseMessage, action, message);
    },
    SET_FALSE_MESSAGE(state, { action, message }) {
      Vue.set(state.falseMessage, action, message);
    },
  },

  actions: {
    // Get Coach Schedule
    async getCoachSchedule({ commit },{month,year}) {

      const action = "getCoachSchedule";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null }); 

      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/schedules/coach/calendar`,
          params: {
            month: month,
            year: year,
          },
          withCredentials: true,
        });

        if (response.status !== 200) throw new Error(`HTTP error! status: ${response.status}`);

        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }

        return data.data;

      } catch (error) {
        handleError(commit, action, error);  
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // Get Coach Course
    async getCoachCourse({ commit }) {

      const action = "getCoachCourse";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });

      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/coach`,
          withCredentials: true,
        });

        if (response.status !== 200) throw new Error(`HTTP error! status: ${response.status}`);

        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }

        commit("SET_COURSECOACH", data.data);

        return data.data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getCourseDetail({ commit },scheduleId) {

      const action = "getCourseDetail";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });

      try {
        const response = await axios({
          method: "GET",
          params: { schedule_id: scheduleId },
          url: `${configuration.backUrl}/course/coach/details`,
          withCredentials: true,
        });

        if (response.status !== 200) throw new Error(`HTTP error! status: ${response.status}`);

        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }

        commit("SET_COURSECOACH", data.data);

        return data.data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    // Get Student In care
    async getStudentInCare({ commit },params) {
      const action = "getStudentInCare";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
    
      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/users/students`,
          params: params,
          withCredentials: true,
        });
    
        if (response.status !== 200) throw new Error(`HTTP error! status: ${response.status}`);
    
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
    
        commit("SET_COURSESTUDENT", data.data);
    
        return data.data.students;
      } catch (error) {
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    // Get Course Student
    async getClassStudent({ commit }, payload) {
      const action = "getClassStudent";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });

      try {
        const response = await axios({
          method: "GET",
          params: payload,
          url: `${configuration.backUrl}/course/coach/student`,
          withCredentials: true,
        });

        if (response.status !== 200) throw new Error(`HTTP error! status: ${response.status}`);

        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }

        commit("SET_COURSESTUDENT", data.data);

        return data.data;
      } catch (error) {
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postCoachCheckIn({ commit }, payload) {
      const action = "postCoachCheckIn";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "POST",
          data: payload, // ใช้ data แทน body
          url: `${configuration.backUrl}/checkin/coach`,
          withCredentials: true,
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postStudentCheckIn({ commit }, payload) {
      const action = "postStudentCheckIn";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "POST",
          data: payload,
          url: `${configuration.backUrl}/checkin/student`,
          withCredentials: true,
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postEvaluateStudent({ commit }, payload) {
      const action = "postEvaluateStudent";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "POST",
          data: payload,
          url: `${configuration.backUrl}/assessments/students`,
          withCredentials: true,
          headers: { 'Content-Type': 'multipart/form-data' },
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getEvaluateStudentList({ commit },payload) {
      const action = "getEvaluateStudentList";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
    
      try {
        const response = await axios({
          method: "GET",
          params: payload,
          url: `${configuration.backUrl}/course/assessment/students`,
          withCredentials: true,
        });
    
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getPotentailStudentList({ commit },payload) {
      const action = "getPotentailStudentList";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
    
      try {
        const response = await axios({
          method: "GET",
          params: payload,
          url: `${configuration.backUrl}/course/potential/students`,
          withCredentials: true,
        });
    
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    
    async postEvaluatePotenial({ commit }, payload) {
      const action = "postEvaluatePotenial";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "POST",
          data: payload,
          url: `${configuration.backUrl}/assessments/potential/students`,
          headers: { 'Content-Type': 'multipart/form-data' },
          withCredentials: true,
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getEvaluatedStudentReport({ commit },payload) {
      const action = "getEvaluatedStudentReport";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "GET",
          params: payload,
          url: `${configuration.backUrl}/course/schedule/assessment`,
          withCredentials: true,
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 

      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getEvaluatedPotentialReport({ commit },payload) {
      const action = "getEvaluatedPotentialReport";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "GET",
          params: payload,
          url: `${configuration.backUrl}/course/schedule/potential`,
          withCredentials: true,
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async getTeachingRecord({ commit }, courseId) {
      const action = "getTeachingRecord";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });

      try {
        const response = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course/schedule`,
          params: {
            course_id: courseId,
            page: 1,
            sort: "ASC",
          },
          withCredentials: true,
        });

        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postClassSummaryAttach({ commit },payload) {
      const action = "postClassSummaryAttach";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
      try {
        const response = await axios({
          method: "PATCH",
          params: payload,
          headers: { 'Content-Type': 'multipart/form-data' },
          url: `${configuration.backUrl}/assessments/upload/teach-summary`,
          withCredentials: true,
        });
    
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async postClassSummary({ commit },formData) {
      const action = "postClassSummary";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "POST",
          data: formData,
          headers: { 'Content-Type': 'multipart/form-data' },
          url: `${configuration.backUrl}/assessments/summary/student`,
          withCredentials: true,
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deleteAssessmentFile({ commit },assessmentLearnerFileId) {
      const action = "deleteAssessmentFile";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/assessments/assessment-learner-file`,
          withCredentials: true,
          params: { assessment_learner_file_id:assessmentLearnerFileId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error); 
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deleteTeachSummaryFile({ commit },teachSummaryFileId) {
      const action = "deleteTeachSummaryFile";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/assessments/teach-summary-file`,
          withCredentials: true,
          params: { teach_summary_file_id:teachSummaryFileId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error); 
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async deletePotentialFile({ commit },potentialLearnerFileId) {
      const action = "deletePotentialFile";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "DELETE",
          url: `${configuration.backUrl}/assessments/potential-learner-file`,
          withCredentials: true,
          params: { potential_learner_file_id:potentialLearnerFileId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error); 
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    async getClassSummary({ commit },payload) {
      const action = "getClassSummary";
      commit("SET_LOADING", { action, status: true });
      commit("SET_ERROR", { action, status: null });
  
      try {
        const response = await axios({
          method: "GET",
          params: payload,
          url: `${configuration.backUrl}/course/schedule/summary`,
          withCredentials: true,
        });
  
        const data = response.data;
        if (!data.success) {
          commit("SET_FALSE_MESSAGE", { action, message: data.message || `${action} Failed` });
        }
        return data;
      } catch (error) {
        
        handleError(commit, action, error); 
        throw error;
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },

    // --------- For Admin -------------------
    async getCoachForAdmin({ commit },courseId) {
      const action = "getCoachForAdmin";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "GET",
          url: `${configuration.backUrl}/course-coach/management`,
          withCredentials: true,
          params: { course_id:courseId },
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error); 
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
    async manageCoachOperation({ commit },payload) {
      const action = "manageCoachOperation";
      commit("SET_LOADING", { action, status: true });
      try {
        const { data } = await axios({
          method: "POST",
          url: `${configuration.backUrl}/course-coach/management/operations`,
          withCredentials: true,
          data: payload,
        });
        return data.data;
      } catch (error) {
        handleError(commit, action, error); 
      } finally {
        commit("SET_LOADING", { action, status: false });
      }
    },
  },
    

  getters: {
    coachCourses: (state) => state.coachCourse,
    courseStudents: (state) => state.courseStudent,
    checkinTime: (state) => state.checkinTime, 
    isLoading: (state) => (action) => !!state.loading[action],
    falseMessage: (state) => (action) =>  state.falseMessage[action],
    fetchError: (state) => state.error,
  },
};
